<template>
  <b-form-textarea
    class="app-textarea"
    :class="{ error: error }"
    v-model="textarea"
    :placeholder="placeholder"
    @input="$emit('input', textarea)"
    :rows="rows"
    :max-rows="maxRows"
    ref="appTextarea"
  />
</template>

<script>
export default {
  name: 'AppTextarea',
  props: {
    rows: {
      type: Number,
      default: 5,
    },
    maxRows: {
      type: Number,
      default: 8,
    },
    error: {
      type: Boolean,
      default: false,
    },
    focusOnMount: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      textarea: '',
    };
  },
  mounted() {
    if (this.focusOnMount) {
      setTimeout(() => {
        this.focusInput();
      }, 200);
    }
  },
  methods: {
    focusInput() {
      try {
        if (this.$refs.appTextarea) {
          this.$refs.appTextarea.focus();
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('no focus available: ', e.message);
      }
    },
  },
};
</script>

<style scoped>
  .app-textarea {
    border: 1px solid rgba(72, 82, 140, 0.15);
    box-shadow: none;
  }
  .app-textarea.error {
    border: 1px solid var(--error-red);
  }
</style>
